import { newMessageId } from './chatCursor';

// 同一次操作失败后的原样重试复用请求编号；修改正文才建立新操作。
export const logicalRequest = (ref, values) => {
  const key = JSON.stringify(values);
  if (!ref.current || ref.current.key !== key) ref.current = { key, data: { ...values, client_request_id: newMessageId() } };
  return ref.current.data;
};
